import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/services/supabase";

export function ProtectedRoute() {
  const location = useLocation();
  const auth = useAuth();
  const session = auth?.session ?? null;
  const loading = auth?.loading ?? true;
  const aczonContext = auth?.aczonContext ?? null;
  const aczonDenied = auth?.aczonDenied ?? false;

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="size-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Restoring session...</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (aczonDenied || !aczonContext) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
}
